import { useTranslation } from 'react-i18next';
import PaginaTexto from '../Compartido/PaginaTexto.jsx';

const TextosCookies = ({ ruta, cookies }) => {

    const { t } = useTranslation();

    return (
        <PaginaTexto
            titulo={t("Política de cookies")}
            eyebrow={t("Legal")}
            imagen={cookies.imagen_cabecera ? ruta + "/" + cookies.imagen_cabecera : null}
            html={cookies.ladesc}
        />
    );
}

export default TextosCookies;
